export enum ContributorJobType {
  collaborator = 'collaborator',
  supervisor = 'supervisor',
  expertAccountant = 'expert-accountant',
  missionChief = 'mission-chief',
  assistant = 'assistant',
  legalReferent = 'legal-referent',
  socialReferent = 'social-referent'
}
